import * as TypVazby from "mc/lib/api/gen/ucty/v1/TypVazby";

const labels = {
    [TypVazby.SAM_K_SOBE]: "Sám k sobě",
    [TypVazby.PRIMY_ZASTUPCE]: "Přímý zástupce",
    [TypVazby.NEPRIMY_ZASTUPCE]: "Nepřímý zástupce",
    [TypVazby.RODIC]: "Rodič",
};

export function label(typ) {
    return labels[typ];
}
